import React from "react";
// Components
import HeaderContainer from "styles/components/headerContainer";
import MKBox from "components/MKBox";
import { Grid } from "@mui/material";
// Styled Components
import { StyledSectionContainer } from "styles/components/SectionContainer/index.styles";
import theme from "assets/theme";
import TeamMemberCard from "../TeamMemberCard";

const MeetOurTeam = ({ title, content }) => {
  return (
    <StyledSectionContainer sx={{ padding: { xs: "4rem 1rem", md: "6rem 2rem" } }}>
      <MKBox sx={{ marginBottom: "4rem" }}>
        <HeaderContainer
          title={title}
          textColor={theme.palette.white.main}
          highlightText={"Team"}
          highlightColor={theme.palette.accent.main}
          variant="h2"
          component="h2"
        />
      </MKBox>

      <Grid
        container
        rowSpacing={4}
        columnSpacing={4}
        sx={{
          justifyContent: content.length < 4 ? "center" : "flex-start",
        }}
      >
        {content.map(({ image, name, title }, index) => (
          <TeamMemberCard key={index} image={image} name={name} title={title} />
        ))}
      </Grid>
    </StyledSectionContainer>
  );
};

export default MeetOurTeam;
